import React from 'react';

import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';
import noop from 'lodash/noop';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

const SideBarNav = ({
  styles,
  isOpen = false,
  onBackdropClick = noop,
  onEscapePress = noop,
  focusModal = focusModalDefault,
  children = null
}) => {
  const component = isOpen ? (<TransitionGroup>
    <CSSTransition classNames="modal" timeout={300} appear unmountOnExit>
      <div
        className={styles.backdrop}
        role="none"
        onClick={onBackdropClick}
        onKeyDown={(e) => {
          if (e.keyCode === 27) {
            onEscapePress();
          }
        }}
        tabIndex="-1"
        ref={focusModal}
      >
        <div className={styles.menu}>
          {children}
        </div>
      </div>
    </CSSTransition>
  </TransitionGroup>) : null;

  return component;
};

SideBarNav.propTypes = {
  styles: PropTypes.object.isRequired,
  isOpen: PropTypes.bool,
  onBackdropClick: PropTypes.func,
  onEscapePress: PropTypes.func,
  focusModal: PropTypes.func,
  children: PropTypes.node,
};

const focusModalDefault = (e) => {
  if (e) {
    e.focus();
  }
};

export default themeable(SideBarNav);
